<template>
  <div id="project-list">
    <!-- Card -->
    <b-card class="shadow-sm project-list">
      <!-- Card header -->
      <template #header>
        <h3>Project List</h3>
      </template>
      <!-- /Card header -->

      <!-- Card body -->
      <template #default>
        <b-container fluid>
          <b-row class="mb-4">
            
            <!-- Filter -->
            <b-col cols="3">
              <chatter-project-filter @reload="retrieveChatterProjectList"/>
            </b-col>
            <!-- /Filter -->
            <b-col cols="7"></b-col>

            <!-- Create button -->
            <b-col cols="2" class="d-flex justify-content-end">
              <b-button variant="success" class="btn btn-primary small"  @click="$router.push('/chatter/chatter-project-new')">Create</b-button>
            </b-col>
            <!-- /Create button -->
          </b-row>
        </b-container>
        <div class="custom-table-container">
        <table class="table table-hover custom-table">
          <colgroup>
            <col width="10%"/>
            <col width="15%"/>
            <col width="40%"/>
            <col width="5%"/>
            <col width="20%"/>
            <!--
            <col width="5%"/>
            -->
            <col width="10%"/>
          </colgroup>
          <thead>
            <tr class="text-center table-dark">
              <th style="vertical-align: middle;">ID</th>
              <th style="vertical-align: middle;">Name</th>
              <th style="vertical-align: middle;">Desc.</th>
              <th style="vertical-align: middle;">Status</th>
              <th style="vertical-align: middle;">Duration</th>    
              <!--      
              <th style="vertical-align: middle;">KDS Methodology</th>
              -->    
              <th style="vertical-align: middle;">Creation Date</th>
            </tr>
          </thead>
          <tbody v-if="projectBoardList.length != 0">
            <tr v-for="item in projectBoardList" :key="item.key" @click="showChatDetail(item.projectId)" style="cursor: pointer;">
              <td class="text-center" style="vertical-align: middle;">{{ item.projectId }}</td>
              <td class="text-center" style="vertical-align: middle;">{{ item.name }}</td>
              <td style="vertical-align: middle;">{{ item.description }}</td>
              <td class="text-center align-middle"
                  style="position: relative;">
                <span class="status-tag"
                      :class="getStatusTagClass(item.status)">{{ item.status }}</span>
              </td>
              <td class="text-center" style="vertical-align: middle;">{{ item.startDate}} ~ {{ item.endDate}}</td>
              <!--
              <td class="text-center" style="vertical-align: middle;">{{ item.projectType}}</td>
              -->
              <td class="text-center" style="vertical-align: middle;">{{ item.creationDate}}</td>        
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11" style="text-align:center">결과가 없습니다.</td>
            </tr>
          </tbody>
        </table>
</div>

<div class="btn-more-area">
          <button class="btn btn-view-more"
                  @click="seeMore()"
                  :disabled="projectBoardList.length >= total || total < 11">
            <span class="icon">
              <SeeMoreIcon/>
            </span>
            <span style="font-weight: 700;">See More&nbsp;</span>
            <span>({{ projectBoardList.length }}/{{ total }})</span>
          </button>
        </div>

      </template>
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import SeeMoreIcon from "@/components/chatter/icons/SeeMoreIcon.vue";
import accessToken from "@/services/accessToken";
import ChatterProjectFilter from "@/components/chatter/project/ChatterProjectFilter.vue";

export default {
  name: "ChatterProjectList",
  components: { 
    Loading, 
    SeeMoreIcon,
    ChatterProjectFilter
   },
  computed: {
    filter() {
      return this.$store.getters['project/filter'];
    },
  },
  data() {
    return {
      loading: false,
      //API로 받아온 모든 project list
      allProjectBoardList:[],
      //화면에 보여지는 project list
      projectBoardList: [],
      total: 0,
      limit: 0,
      offset: 0,
      PAGE_LIMIT : 10,
      colorObj: {
        black: 'black',
        goldenRod: 'GoldenRod',
        darkOrange: 'DarkOrange'
      },

      retrieveListLoading: false,
    }
  },
  methods: {
    seeMore() {

      if (this.projectBoardList && this.projectBoardList.length > 0) {
          this.offset = this.offset + this.limit;

      }
      this.projectBoardList=this.allProjectBoardList.slice(0,this.offset+this.limit);

      //this.retrieveChatterProjectList();
    },
    showChatDetail(projectId) {
      this.pushRoute({ name: "projectDetail", params: { id: projectId } });
    },
    async retrieveChatterProjectList() {
      this.retrieveListLoading = true;
      var status="";
      //default status 값이 ""이므로 -> "OPEN"으로 변경
      if(this.filter.status==""){
        status="OPEN";
      }
      else{
        //"ALL", "CLOSED"
        status=this.filter.status;
      }

      var params = {
        'status': status,
        //limit 무한으로 설정
        'limit': 10000,
        'offset': 0
      };

      try{
        let response=await axios.post('chatter/retrieveProjectBoardList', params, {
          headers: {
              Authorization: accessToken()
          }
        });
        this.allProjectBoardList=response.data.list;

        //creationDate 기준으로 내림차순 정렬
        this.allProjectBoardList.sort((a,b)=>new Date(a.creationDate)-new Date(b.creationDate)).reverse();
        this.projectBoardList=this.allProjectBoardList.slice(0,this.PAGE_LIMIT);
        /* KDS Methodology
        for(let project of this.projectBoardList){
          if(project.projectType != null && (project.projectType == 'true' || project.projectType.toUpperCase() == 'KDS')){
            project.projectType = 'O';
          }else{
            project.projectType = 'X';
          }
        }
        */
        this.total = response.data.total;
      }catch (error) {
        if (error.status != 401) {
            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
        }
      } finally {
        this.retrieveListLoading = false;
      }          
    },
    getStatusTagClass(status) {
      if (status === 'OPEN') return 'open'
      else if (status === 'CLOSED') return 'closed'
      
    },
  },
  created() {
    this.limit = this.PAGE_LIMIT;
    this.retrieveChatterProjectList();
  },
}
</script>
<style>
#project-list .btn {
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

#project-list .btn:focus {
    box-shadow: none;
}

#project-list .btn-primary {
    width: 280px;
    height: 60px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
}

#project-list .btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
}

#project-list .btn-primary.disabled,
.btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
}

#project-list .btn-primary.small {
    width: 148px;
    height: 40px;
}

#project-list .btn-line {
    position: relative;
    width: 100px;
    height: 60px;
    border: 1px solid #C4C4CD;
    background-color: transparent;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: inherit;
}

#project-list .btn-line:hover {
    color: #2E2E38;
    border: 1px solid #2E2E38;
    background-color: transparent;
}

#project-list .btn-line.disabled,
#project-list .btn-line:disabled {
    border: 1px solid #DDDDE3;
    background-color: transparent;
}

#project-list .btn-line.small {
    height: 40px;
    text-align: center;
}

#project-list .btn-refresh {
    height: auto;
    padding: 0;
}


#project-list .table td {
    vertical-align: middle;
}
#project-list .card.project-list {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#project-list .card.project-list .card-header {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
    padding-bottom: calc(max(2.666rem, 2.0833vw) - 1rem);
    border-radius: 30px 30px 0 0;
    border-bottom: none;
}

#project-list .custom-table-container {
    margin-top: 2.666rem;
    padding: 0.666rem;
    border-radius: 20px;
    background-color: #F6F6FA;
}

#project-list .table.custom-table {
    margin-bottom: 0;
}

#project-list .table.custom-table tr {
    color: #2E2E38;
    background-color: #FFF;
}

#project-list .table.custom-table tr:hover {
    background-color: #FAFAFA;
}

#project-list .table.custom-table thead th,
#project-list .table-bordered.custom-table th {
    height: 70px;
    padding-top: calc(0.75rem - 0.666rem);
    background-color: #F6F6FA;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #C4C4CD;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
    vertical-align: middle;
    white-space: nowrap;
}

#project-list .table.custom-table td {
    min-height: 80px;
    padding: 1.333rem 0.666rem;
    border-top: 1px solid #E7E7EE;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    vertical-align: middle;
}

#project-list .table.custom-table td .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#project-list .table.custom-table td .title-wrap .title-container {
    flex-grow: 1;
}

#project-list .table.custom-table td .title-wrap .title-text {
    font-weight: 700 !important;
}

#project-list .table.custom-table td .title-wrap .chatter-hierarchy {
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

#project-list .btn-more-area {
    display: flex;
    justify-content: center;
    margin-top: 2.666rem;
}

#project-list .btn-more-area .btn-view-more {
    display: inline-block;
    width: auto;
    height: auto;
    margin: 0;
    padding: 1.3rem 3.3rem 1.3rem 3.033rem;
    border-radius: 60px !important;
    background-color: #E7E7EE;
}

#project-list .btn-more-area .btn-view-more .icon {
    margin-top: -3px;
    margin-right: 0.533rem;
}

#project-list .btn-more-area .btn-view-more span {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    line-height: 150%;
}

#project-list .btn-more-area .btn-view-more:hover {
    background-color: #C4C4CD;
}

#project-list .table.custom-table .status-tag {
    display: inline-block;
    width: 100px;
    height: 29px;
    padding: 4px;
    border-radius: 38px;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

#project-list .table.custom-table .status-tag.in-progress {
    background-color: #F5ECD6;
    color: #FF5C00;
}

#project-list .table.custom-table .status-tag.in-progress-red {
    background-color: #F5D6D6;
    color: #F00;
}

#project-list .table.custom-table .status-tag.to-do {
    background-color: #F6F6FA;
    color: #2E2E38;
}

#project-list .table.custom-table .status-tag.open {
    background-color: #CFDDFF;
    color: #1755CC;
}

#project-list .table.custom-table .status-tag.closed {
    background-color: #D7F5D6;
    color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
    background-color: #E4E4EA;
    color: rgba(116, 116, 128, 0.70);
}
</style>